import { createContext, useContext, useLayoutEffect } from "react";

export interface RailComposerCard {
  open: boolean;
  setOpen: (open: boolean) => void;
}

/**
 * Whether one of the rail's own cards (the cart scenario ask) is open above
 * the composer. The rail's chips step aside while it is (ENG-7894): the card
 * always sits directly on the input, and the chips come back once it is
 * dismissed. Survey questions need no report — a parked requirement already
 * says so. Provided by `RailComposerCardProvider`.
 */
export const RailComposerCardContext = createContext<RailComposerCard>({
  open: false,
  setOpen: () => undefined,
});

/**
 * Reports a card's visibility for as long as it is mounted. A layout effect,
 * so the chips are already gone in the frame the card first paints.
 */
export const useReportRailComposerCard = (open: boolean) => {
  const { setOpen } = useContext(RailComposerCardContext);
  useLayoutEffect(() => {
    setOpen(open);
    return () => setOpen(false);
  }, [open, setOpen]);
};

export const useRailComposerCardOpen = () =>
  useContext(RailComposerCardContext).open;
